export const serialize = (obj) => {
  let string = [];
  for (let value in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, value)) {
      string.push(encodeURIComponent(value) + '=' + encodeURIComponent(obj[value]));
    }
  }
  return string.join('&');
};
